<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="证书管理" name="1"></el-tab-pane>
      <el-tab-pane label="人员管理" name="2"></el-tab-pane>
      <el-tab-pane label="机构管理" name="3"></el-tab-pane>
      <el-tab-pane label="信息统计" name="4"></el-tab-pane>
      <el-tab-pane label="批量操作" name="5"></el-tab-pane>
      <div class="tab-content">
        <keep-alive>
          <component :is="curTabcompnents[activeName]"></component>
        </keep-alive>
      </div>
    </el-tabs>
  </div>
</template>
<script>
  import CertManage from '@/components/CertManage'
  import PersonManage from '@/components/PersonManage'
  import OrgManage from '@/components/OrgManage'
  import BatchProcess from '@/components/BatchProcess'
  import Statistic from '@/components/Statistic'
  export default {
    data() {
      return {
        activeName: '1',
        curTabcompnents: {
          '1': 'CertManage',
          '2': 'PersonManage',
          '3': 'OrgManage',
          '4': 'Statistic',
          '5': 'BatchProcess',
        }
      };
    },
    components: {
      CertManage, PersonManage, BatchProcess, OrgManage, Statistic
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue